export {
  baseMenuContentPropDefs as dropdownMenuContentPropDefs,
  baseMenuItemPropDefs as dropdownMenuItemPropDefs,
  baseMenuCheckboxItemPropDefs as dropdownMenuCheckboxItemPropDefs,
  baseMenuRadioItemPropDefs as dropdownMenuRadioItemPropDefs,
} from './_internal/base-menu.props.js';
